module.exports = __webpack_public_path__ + "img/ft.34e5c818.png";